import { render, staticRenderFns } from "./BaseComponentLoader.vue?vue&type=template&id=335a9b76&scoped=true&"
import script from "./BaseComponentLoader.vue?vue&type=script&lang=js&"
export * from "./BaseComponentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a9b76",
  null
  
)

export default component.exports